import CustomInput from "./CustomInput";

const UKRAINIAN_SENTENCE = /^([А-ЕЖ-ЩЬЮЯЇІЄҐ0-9]+[.,]?[ ]?['-]?)*$/;
const MAX_SIZE = 256;

class SentenceInput extends CustomInput {
  transform = value => {
    // console.log(value);
    
    return  value
    .substring(0, MAX_SIZE)
    .toUpperCase();
  }
   

  validate = value => UKRAINIAN_SENTENCE.test(value);
}

export default SentenceInput;

// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// export default function SentenceInput(props) {
//   const mask = "W".repeat(40);
//
//   return (
//     <MaskedInput
//       mask={mask}
//       placeholder=""
//       placeholderChar=" "
//       {...props}
//       formatCharacters={{
//         W: {
//           validate: char => /[А-ЕЖ-ЩЬЮЯЇІЄҐа-еж-щьюяїієґ'-. ]/.test(char),
//           transform: char => char.toUpperCase()
//         }
//       }}
//     />
//   );
// }
